import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CardFooter from './CardFooter';
import { valueFormatter } from '../DataTable/utils';
import { useWidgetContext } from '../Widget/WidgetContext';

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const ValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  color: var(--text-primary);
  font-size: 42px;
`;

const Label = styled.div`
  font-size: 20px;
  padding-left: 2px;
`;

interface Props {
  value?: number;
  marketValue?: number;
  label: string;
  footerLabel: string;
  footerDifference?: number | null;
  valueDisplay?: number;
}

const CardLabelContent = ({
  value = 0,
  marketValue = 0,
  label,
  footerLabel,
  footerDifference,
  valueDisplay,
}: Props) => {
  const { type } = useWidgetContext();
  const { community } = useCommunityViewContext();
  const formattedValue = valueFormatter(value, type, false, undefined, community, false);
  const formattedMarketValue = valueFormatter(marketValue, type, false, undefined, community);

  return (
    <Content>
      <ValueContainer>
        <div>
          <span>{formattedValue || 0}</span>
        </div>
        <Label>{label}</Label>
      </ValueContainer>
      <CardFooter
        label={footerLabel}
        value={marketValue ? formattedMarketValue : 'Not Available'}
        positive={marketValue >= value}
        widgetType={type}
        valueDisplay={valueDisplay}
        difference={footerDifference ?? null}
      />
    </Content>
  );
};

export default CardLabelContent;
